export const BasicColors = {
	primary: "#00bcd4",
	secondary: "#ff4081",
	success: "#4caf50",
	warning: "#ff9800",
	danger: "#f44336",
	info: "#2196f3",
	light: "#f4f4f4",
	dark: "#212121",
	white: "#ffffff",
	black: "#000000",
	gray: "#9e9e9e",
	gray2: "#f5f5f5",
	gray3: "#eeeeee",
	gray4: "#e0e0e0",
	gray5: "#bdbdbd",
	gray6: "#757575",
	gray7: "#616161",
	gray8: "#424242",
	gray9: "#dee2e6",
	gray10: "#F3F2F1",
	orange: " #f96209",
	orangeHover: "#E35806",
	purple: "#7676d2",
	primaryPurple: "#4b4b7b",
	cemOrange: "#f96209",
	backgroundGreySidebar: "#3F3D56",
	warning2: "#FC74B3",
	cemPurple: "#3f3d56",
	MaleActive: "#15AABF",
	FemaleActive: "#FC74B3",
	yellow: "#eef982",
	lightGrey: "#f3f2f1",
	primlightbg: "#d9d8fb",
};

export const Colors = {
	primary: "#F96209",
	label: "#605F60",
	turquoise: "#18AEAD",
	terrible: "#cc5858",
	terribleIcon: "#FF8B8B",
	poor: "#ca5215",
	poorIcon: "#FCA57A",
	generic: "#ed9e00",
	genericIcon: "#FEE591",
	good: "#59ad62",
	goodIcon: "#B9FBC0",
	excellent: "#049493",
	excellentIcon: "#A3DFDE",
	nosentimentIcon: "#c3c3c3",
	primaryText: "#333",
};

export const SwimlaneColors = {
	"#FFFFFF": { color: "#FFFFFF" },
	"#6B7280": { color: "#F9FAFB" },
	"#EF4444": { color: "#FEF2F2" },
	"#EC4899": { color: "#FDF2F8" },
	"#D946EF": { color: "#FDF4FF" },
	"#A855F7": { color: "#FAF5FF" },
	"#3B82F6": { color: "#EFF6FF" },
	"#0EA5E9": { color: "#F0F9FF" },
	"#06B6D4": { color: "#ECFEFF" },
	"#22C55E": { color: "#F0FDF4" },
	"#EAB308": { color: "#FEFCE8" },
	"#F97316": { color: "#FFF7ED" },
};

export const CustomLibraryColors = [
	"#F1F5F9",
	"#FEE2E2",
	"#FCE7F3",
	"#FAE8FF",
	"#F3E8FF",
	"#DBEAFE",
	"#E0F2FE",
	"#CFFAFE",
	"#DCFCE7",
	"#FEF9C3",
	"#FFEDD5",
	"#E2E8F0",
	"#FECACA",
	"#FBCFE8",
	"#F5D0FE",
	"#E9D5FF",
	"#BFDBFE",
	"#BAE6FD",
	"#A5F3FC",
	"#BBF7D0",
	"#FEF08A",
	"#FED7AA",
	"#94A3B8",
	"#F87171",
	"#F472B6",
	"#E879F9",
	"#C084FC",
	"#60A5FA",
	"#38BDF8",
	"#22D3EE",
	"#4ADE80",
	"#FACC15",
	"#FB923C",
	"#334155",
	"#B91C1C",
	"#BE185D",
	"#A21CAF",
	"#7E22CE",
	"#1D4ED8",
	"#0369A1",
	"#0E7490",
	"#15803D",
	"#A16207",
	"#C2410C",
];

export const CustomizationColors = {
	"#F3F4F6": { backgroundColor: "#F3F4F6", color: "#1E293B", borderColor: "#D1D5DB", description: "GREY" },
	"#FEE2E2": { backgroundColor: "#FEE2E2", color: "#991B1B", borderColor: "#FCA5A5", description: "RED" },
	"#FCE7F3": { backgroundColor: "#FCE7F3", color: "#9D174D", borderColor: "#F9A8D4", description: "PINK" },
    "#F3E8FF": { backgroundColor: "#F3E8FF", color: "#6B21A8", borderColor: "#D8B4FE", description: "PURPLE" },
    "#DBEAFE": { backgroundColor: "#DBEAFE", color: "#1E40AF", borderColor: "#93C5FD", description: "BLUE" }, 
    "#DCFCE7": { backgroundColor: "#DCFCE7", color: "#166534", borderColor: "#86EFAC", description: "GREEN" },
	"#FEF9C3": { backgroundColor: "#FEF9C3", color: "#854D0E", borderColor: "#FDE047", description: "YELLOW" },
	"#FFEDD5": { backgroundColor: "#FFEDD5", color: "#9A3412", borderColor: "#FDBA74", description: "ORANGE" },
};
